import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

export interface PaginationActivity {
  exercises: Exercise[];
  isSent: boolean;
  isEvaluable: boolean;
}

export interface Exercise {
  number: number;
  id: string;
  isHidden: boolean;
  status?: PageActivityStatus;
}

export enum PageActivityStatus {
  TO_DO,
  INCOMPLETED,
  COMPLETED,
  SAVED,
}

@Component({
  selector: 'tekman-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
})
export class PaginationComponent implements OnInit {
  @Input() paginationActivity: PaginationActivity;
  @Input() isTeacher = false;
  @Input() selectedClass: string;
  @Input() selectedPage: number;
  @Input() completedStatusClass: string;
  @Input() incompletedStatusClass: string;
  @Input() toDoStatusClass: string;
  @Input() showProgress: boolean;

  @Output() nPageChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() pageVisibilityChange: EventEmitter<Exercise> = new EventEmitter<Exercise>();

  public readonly MAX_EXERCISES_INLINE = 15;

  public readonly PageActivityStatus = PageActivityStatus;
  public lastPage: number;
  public firstPage = 0;

  ngOnInit(): void {
    if (this.paginationActivity.exercises.length > this.MAX_EXERCISES_INLINE) {
      this.lastPage = this.MAX_EXERCISES_INLINE - 1;
    } else {
      this.lastPage = this.MAX_EXERCISES_INLINE;
    }
  }

  pageChange(exercise: Exercise): void {
    this.nPageChange.emit(exercise.number);
  }

  clickOnVisibility(exercise: Exercise): void {
    this.pageVisibilityChange.emit(exercise);
  }

  nextPage() {
    if (this.firstPage === 0) {
      this.lastPage--;
    }
    if (this.lastPage === this.paginationActivity.exercises.length - 1) {
      this.firstPage--;
    }
    this.firstPage++;
    this.lastPage++;
  }

  previousPage() {
    this.firstPage--;
    this.lastPage--;

    if (this.firstPage === 0) {
      this.lastPage++;
    }
    if (this.lastPage === this.paginationActivity.exercises.length - 1) {
      this.firstPage++;
    }
  }
}
